export const MSGS = {
  // 1. Initial Welcome / Application Created
  WELCOME: (d) => `வணக்கம் 🙏

திருப்பதி டாக்குமென்டேஷன் மூலம் உங்கள் ஆவண பதிவு விண்ணப்பம் வெற்றிகரமாக உருவாக்கப்பட்டுள்ளது. 📄✨

விண்ணப்ப எண்: ${d.app_no}

எங்கள் நிபுணர் குழு உங்கள் விண்ணப்பத்தை விரைவாக செயல்படுத்தும். தேவையான தகவல்கள் அல்லது புதுப்பிப்புகள் இருந்தால், உங்களை தொடர்பு கொள்வோம். 🔄

உதவி தேவைப்பட்டால் எங்களை தொடர்பு கொள்ளவும்:
📞 73394 89005

நன்றி! 😊
திருப்பதி டாக்குமென்டேஷன்`,

WELCOME1: (d) => `வணக்கம் 🙏

திருப்பதி டாக்குமென்டேஷன் மூலம் உங்கள் ஆவண பதிவு விண்ணப்பம் வெற்றிகரமாக உருவாக்கப்பட்டுள்ளது. 📄✨

விண்ணப்ப எண்: ${d.app_no}
ஆவண எண்: ${d.document_number}

எங்கள் நிபுணர் குழு உங்கள் விண்ணப்பத்தை விரைவாக செயல்படுத்தும். தேவையான தகவல்கள் அல்லது புதுப்பிப்புகள் இருந்தால், உங்களை தொடர்பு கொள்வோம். 🔄

உதவி தேவைப்பட்டால் எங்களை தொடர்பு கொள்ளவும்:
📞 73394 89005

நன்றி! 😊
திருப்பதி டாக்குமென்டேஷன்`,

WELCOME2: (d) => `வணக்கம் 🙏

திருப்பதி டாக்குமென்டேஷன் மூலம் உங்கள் ஆவண பதிவு விண்ணப்பம் வெற்றிகரமாக உருவாக்கப்பட்டுள்ளது. 📄✨

விண்ணப்ப எண்: ${d.app_no}

எங்கள் நிபுணர் குழு உங்கள் விண்ணப்பத்தை விரைவாக செயல்படுத்தும். தேவையான தகவல்கள் அல்லது புதுப்பிப்புகள் இருந்தால், உங்களை தொடர்பு கொள்வோம். 🔄

உதவி தேவைப்பட்டால் எங்களை தொடர்பு கொள்ளவும்:
📞 73394 89005

நன்றி! 😊
திருப்பதி டாக்குமென்டேஷன்`,

  // 2. Guideline Value (GV) Update
  GV: (d) => `வணக்கம் 🙏

திருப்பதி டாக்குமென்டேஷன் மூலம் உங்கள் விண்ணப்பத்திற்கான Guideline Value சரிபார்க்கப்பட்டுள்ளது. 📊

விண்ணப்ப எண்: ${d.app_no}
Guideline Value: ₹${d.gv}

இந்த தகவல் உங்கள் விண்ணப்ப செயல்முறைக்காக பதிவுசெய்யப்பட்டுள்ளது. தொடர்ந்து செயல்படுத்தும் பணிகள் நடைபெற்று வருகின்றன. 🔄

மேலும் தகவல்களுக்கு அல்லது உதவிக்கு:
📞 73394 89005

நன்றி! 😊
திருப்பதி டாக்குமென்டேஷன்`,

  // 3. Encumbrance Certificate (EC) Update
  EC: (d) => `வணக்கம் 🙏

திருப்பதி டாக்குமென்டேஷன் மூலம் உங்கள் விண்ணப்பத்திற்கான வில்லங்கச் சான்றிதழ் (EC) பெறப்பட்டுள்ளது. 📄

விண்ணப்ப எண்: ${d.app_no}
EC எண்: ${d.ec_no}

உங்கள் விண்ணப்பம் தொடர்ந்து செயல்படுத்தப்பட்டு வருகிறது. மேலும் புதுப்பிப்புகள் விரைவில் பகிரப்படும். 🔄

உதவி தேவைப்பட்டால் எங்களை தொடர்பு கொள்ளவும்:
📞 73394 89005

நன்றி! 😊
திருப்பதி டாக்குமென்டேஷன்`,

  // 4. Token/Appointment Booking
  TOKEN: (d) => `வணக்கம் 🙏

திருப்பதி டாக்குமென்டேஷன் மூலம் உங்கள் பதிவு செயல்முறைக்கான டோக்கன் வெற்றிகரமாக உருவாக்கப்பட்டுள்ளது. 🎫

விண்ணப்ப எண்: ${d.app_no}
டோக்கன் எண்: ${d.token}
தேதி: ${d.date}
நேரம்: ${d.time}
அலுவலகம்: ${d.office}

தயவுசெய்து வருவதற்கு முன் உங்கள் Draft Document-ஐ சரிபார்த்து, அனைவரின் அடையாள அட்டைகளை (ID Proof) கொண்டு வரவும். 🪪📄

குறிப்பிட்ட தேதி மற்றும் நேரத்தில் அலுவலகத்திற்கு வருகை தரவும். ⏰

மேலும் உதவிக்கு:
📞 73394 89005

நன்றி! 😊
திருப்பதி டாக்குமென்டேஷன்`,

  // 5. Payment / Fees Pending
  RM: (d) => `வணக்கம் 🙏

இது உங்கள் பதிவு டோக்கன் நினைவூட்டல் செய்தி. 🔔

விண்ணப்ப எண்: ${d.app_no} 
டோக்கன் எண்: ${d.token}  
தேதி: ${d.date}  
நேரம்: ${d.time}  
அலுவலகம்: ${d.office}

தயவுசெய்து குறைந்தது 1 மணி நேரத்திற்கு முன் எங்கள் அலுவலகத்திற்கு வருகை தரவும். ⏰

இடம் (Location): https://c.jkbs.in/td 📍

வருவதற்கு முன் உங்கள் Draft Document மற்றும் அனைவரின் அடையாள அட்டைகளை (ID Proof) சரிபார்த்து கொண்டு வரவும். 🪪📄

மேலும் உதவிக்கு:
📞 73394 89005

நன்றி! 😊
திருப்பதி டாக்குமென்டேஷன்`,

  // 6. Appointment Reminder (Sent 1 day before)
  REGISTERED: (d) => `வணக்கம் 🙏

திருப்பதி டாக்குமென்டேஷன் மூலம் உங்கள் ஆவணம் வெற்றிகரமாக பதிவு செய்யப்பட்டுள்ளது. ✅📄

விண்ணப்ப எண்: ${d.app_no}  
ஆவண எண்: ${d.document_number}

பதிவு செயல்முறை நிறைவடைந்தது. 🎉  
அடுத்தடுத்த நடவடிக்கைகள் குறித்து விரைவில் உங்களை தொடர்பு கொள்வோம்.

மேலும் உதவிக்கு:
📞 73394 89005

நன்றி! 😊  
திருப்பதி டாக்குமென்டேஷன்
`,

  // Presenceless Online — document submitted
  SUBMITTED: () => `வணக்கம் 🙏

திருப்பதி டாக்குமென்டேஷன் மூலம் உங்கள் ஆவணம் வெற்றிகரமாக சமர்ப்பிக்கப்பட்டுள்ளது. ✅📄

மேலும் உதவிக்கு:
📞 73394 89005

நன்றி! 😊
திருப்பதி டாக்குமென்டேஷன்
`,

  // 7. Process Completed / Registered Successfully
  COLLECTED: (d) => `வணக்கம் 🙏

திருப்பதி டாக்குமென்டேஷன் மூலம் உங்கள் ஆவணம் பதிவு அலுவலகத்திலிருந்து எங்கள் அலுவலகத்திற்கு பெறப்பட்டுள்ளது. 📄📥

விண்ணப்ப எண்: ${d.app_no}  
ஆவண எண்: ${d.document_number}  
அலுவலகம்: ${d.office}

உங்கள் ஆவணம் பாதுகாப்பாக எங்களிடம் உள்ளது. அடுத்தடுத்த செயல்முறைகள் நடைபெற்று வருகின்றன. 🔄

மேலும் தகவல்களுக்கு அல்லது உதவிக்கு:
📞 73394 89005

நன்றி! 😊  
திருப்பதி டாக்குமென்டேஷன்`,

COLLECTED1: (d) => `வணக்கம் 🙏

திருப்பதி டாக்குமென்டேஷன் மூலம் உங்கள் ஆவணம் பதிவு அலுவலகத்திலிருந்து எங்கள் அலுவலகத்திற்கு பெறப்பட்டுள்ளது. 📄📥

விண்ணப்ப எண்: ${d.app_no}  
அலுவலகம்: ${d.office}

உங்கள் ஆவணம் பாதுகாப்பாக எங்களிடம் உள்ளது. அடுத்தடுத்த செயல்முறைகள் நடைபெற்று வருகின்றன. 🔄

மேலும் தகவல்களுக்கு அல்லது உதவிக்கு:
📞 73394 89005

நன்றி! 😊  
திருப்பதி டாக்குமென்டேஷன்`,

  // 8. Documents Ready for Collection
 SCANNED: (d) => `வணக்கம் 🙏

திருப்பதி டாக்குமென்டேஷன் மூலம் உங்கள் ஆவணங்கள் அனைத்தும் சரிபார்க்கப்பட்டு, Scan செய்யப்பட்டு. 📄🔍

EC (வில்லங்கச் சான்றிதழ்) அனைத்தும் சரியாக உள்ளன. ✅

விண்ணப்ப எண்: ${d.app_no}  
ஆவண எண்: ${d.document_number}

தயவுசெய்து எங்கள் அலுவலகத்திற்கு வந்து உங்கள் ஆவணங்களை பெற்றுக்கொள்ளவும். 📥

இடம் (Location): https://c.jkbs.in/td 📍

மேலும் உதவிக்கு:
📞 73394 89005

நன்றி! 😊  
திருப்பதி டாக்குமென்டேஷன்`,

 THANK: (d) => `வணக்கம் 🙏

திருப்பதி டாக்குமென்டேஷன் மீது வைத்த நம்பிக்கைக்கு நன்றி! 😊

உங்கள் ஆவணங்கள் வெற்றிகரமாக வழங்கப்பட்டுள்ளன. 📄✨

விண்ணப்ப எண்: ${d.app_no}  
ஆவண எண்: ${d.document_number}

எங்கள் சேவை குறித்து உங்கள் மதிப்பீட்டை பகிர்ந்து உதவுங்கள். உங்கள் கருத்து எங்களுக்கு மிக முக்கியமானது. ⭐

Google Review:
https://c.jkbs.in/tdr

மேலும் உதவிக்கு:
📞 73394 89005

மீண்டும் நன்றி! 🙏  
திருப்பதி டாக்குமென்டேஷன்
`, 

THANK1: (d) => `வணக்கம் 🙏

திருப்பதி டாக்குமென்டேஷன் மீது வைத்த நம்பிக்கைக்கு நன்றி! 😊

உங்கள் ஆவணங்கள் வெற்றிகரமாக வழங்கப்பட்டுள்ளன. 📄✨

விண்ணப்ப எண்: ${d.app_no}  

எங்கள் சேவை குறித்து உங்கள் மதிப்பீட்டை பகிர்ந்து உதவுங்கள். உங்கள் கருத்து எங்களுக்கு மிக முக்கியமானது. ⭐

Google Review:
https://c.jkbs.in/tdr

மேலும் உதவிக்கு:
📞 73394 89005

மீண்டும் நன்றி! 🙏  
திருப்பதி டாக்குமென்டேஷன்
`
};